import styled from 'styled-components';

export const UnstyledButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  alignitems: center;
  justifycontent: center;
`;
